import { Logger } from '@main/utils/logger';
import { BusIframe } from '@main/bus-layer/bus-iframe';
import type { BusEvent } from '@main/utils/bus-event-promisifier';
import { BusEventsPromisifier } from '@main/utils/bus-event-promisifier';
import type { Tag } from '@entities/tag';
import type { BusTagsPayload } from '@main/event-listeners/payloads/bus-tags.payload';
import type { FetchTagsEventPublisher } from './fetch-tags.usecase';

// The bus responds to API.FETCH_TAGS with API.FETCH_TAGS_FULFILLED (payload is
// the tags array) or API.FETCH_TAGS_REJECTED; promisifySyncEvent below listens
// for both on the window and resolves / rejects accordingly.

export class FetchTagsPublisher implements FetchTagsEventPublisher {
  private logger = new Logger();

  async publish(): Promise<Tag[]> {
    const iframe = await BusIframe.getIframe();

    const event: BusEvent = {
      type: 'API.FETCH_TAGS',
    };

    this.logger.info('Publishing bus event', { action: event.type });

    const response = (await BusEventsPromisifier.promisifySyncEvent({
      event,
      fulfilled: 'API.FETCH_TAGS_FULFILLED',
      rejected: 'API.FETCH_TAGS_REJECTED',
      target: iframe,
    })) as BusTagsPayload;

    const tags: Tag[] = response ?? [];

    this.logger.info('Fetched tags from Bus', {
      count: tags.length,
    });

    return tags;
  }
}
